import { Page, Layout, Card, BlockStack, SkeletonBodyText, SkeletonDisplayText } from "@medentic/polaris-react";
import { AppPageWrapper } from "@shared/ui";
import { useTranslation } from "react-i18next";

export default function BrandDetailsSkeleton() {
  const { t } = useTranslation();

  return (
    <AppPageWrapper>
      <Page fullWidth backAction={{ content: t("common.back"), onAction: () => {} }}>
        <Layout>
          <Layout.Section>
            <BlockStack gap="400">
              {/* Overview Card Skeleton */}
              <Card>
                <BlockStack gap="400">
                  <SkeletonDisplayText size="small" />
                  <BlockStack gap="200">
                    <SkeletonBodyText lines={3} />
                    <SkeletonBodyText lines={2} />
                  </BlockStack>
                </BlockStack>
              </Card>

              {/* Branding & Media Skeleton */}
              <Card>
                <BlockStack gap="400">
                  <SkeletonDisplayText size="small" />
                  <BlockStack gap="200">
                    <SkeletonBodyText lines={4} />
                  </BlockStack>
                </BlockStack>
              </Card>

              {/* Contact Information Skeleton */}
              <Card>
                <BlockStack gap="400">
                  <SkeletonDisplayText size="small" />
                  <BlockStack gap="200">
                    <SkeletonBodyText lines={3} />
                  </BlockStack>
                </BlockStack>
              </Card>

              {/* Social Media Profiles Skeleton */}
              <Card>
                <BlockStack gap="400">
                  <SkeletonDisplayText size="small" />
                  <BlockStack gap="200">
                    <SkeletonBodyText lines={3} />
                  </BlockStack>
                </BlockStack>
              </Card>
            </BlockStack>
          </Layout.Section>

          <Layout.Section variant="oneThird">
            <BlockStack gap="400">
              {/* Status Card Skeleton */}
              <Card>
                <BlockStack gap="400">
                  <SkeletonDisplayText size="small" />
                  <BlockStack gap="200">
                    <SkeletonBodyText lines={2} />
                  </BlockStack>
                </BlockStack>
              </Card>

              {/* Translations Card Skeleton */}
              <Card>
                <BlockStack gap="400">
                  <SkeletonDisplayText size="small" />
                  <BlockStack gap="200">
                    <SkeletonBodyText lines={1} />
                  </BlockStack>
                </BlockStack>
              </Card>
            </BlockStack>
          </Layout.Section>
        </Layout>
      </Page>
    </AppPageWrapper>
  );
}
